import React, { useCallback } from "react";
import moment from "moment";
import logo from "../../assets/logo.png";
import logoDark from "../../assets/logoDark.png";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../../scripts/helperScripts";
import getAge from "../services/ageService";

function ClientFormHeader({
  formTitle,
  clientData,
  formsyDetails,
  letterhead,
  hideHeaderOnPrint = false,
}) {
  const username = JSON.parse(localStorage.getItem("safyInfo")).user
    .displayName;

  const getClientInfo = useCallback(() => {
    if (clientData) {
      let clientInfo = `${clientData.fullName}`;
      if (clientData.mpi) clientInfo += ` - ${clientData.mpi}`;
      if (clientData.sex) clientInfo += ` - ${getFieldName(clientData.sex)}`;
      if (clientData.dob)
        clientInfo += ` - ${getFieldDate(clientData.dob)} - ${getAge(
          getFieldText(clientData.dob),
          getFieldText(clientData.deceaseddate)
        )}`;

      return clientInfo;
    }

    return "";
  }, [clientData]);

  return (
    <>
      {letterhead !== undefined ? (
        <div className="d-none d-print-inline">{letterhead}</div>
      ) : null}
      <div className="bg-safy2-1 p-2 text-white rounded-top d-print-none">
        <div className="clearfix">
          <img
            src={logo}
            alt="logo"
            className="me-4"
            style={{ float: "left", width: "48px" }}
          ></img>
          <h3 style={{ float: "left" }}>{formTitle}</h3>
          {formsyDetails.Active ? (
            <strong className="d-print-none" style={{ float: "right" }}>
              {username}
            </strong>
          ) : null}
        </div>
        <div className="clearfix">
          <strong style={{ float: "left" }}>{getClientInfo()}</strong>
          {formsyDetails.ModifiedOn !== undefined ? (
            <strong className="d-print-none" style={{ float: "right" }}>
              {formsyDetails.Active ? "Last saved" : "Deactivated"} on{" "}
              {moment
                .utc(formsyDetails.ModifiedOn)
                .local()
                .format("MMM D, YYYY [at] h:mm A")}{" "}
              by {formsyDetails.ModifiedByName}
            </strong>
          ) : (
            <strong
              className="d-print-none text-warning d-flex"
              style={{ float: "right" }}
            >
              <i className="fas fa-exclamation-triangle mt-1 me-1"></i>
              To prevent loss of work, please click save.
            </strong>
          )}
        </div>
      </div>
      {!hideHeaderOnPrint ? (
        <div className="d-none d-print-inline p-2 rounded-top">
          <div className="clearfix">
            <img
              src={logoDark}
              alt="logo"
              className="me-4 float-start"
              style={{ width: "48px" }}
            ></img>
            <h3 style={{ float: "left" }}>{formTitle}</h3>
          </div>
          <div>{getClientInfo()}</div>
        </div>
      ) : null}
    </>
  );
}

export default ClientFormHeader;
